// eslint-disable-next-line import/prefer-default-export
export function compact<T>(arr: readonly (T | undefined)[]): T[] {
  return arr.filter((item) => !!item) as NonNullable<T>[];
}
